import { CategoryField } from "../typings/categories";
import { thor } from "../typings/thor";
import slugify from "../utils/slugify";

export class IeUrlBuilderService {
    public static $inject: string[] = [
        "configService",
        "sitesService",
        "utilsService"
    ];

    private static FIELDS: {} = {
        [CategoryField.MOA]: "meubles-objets-art",
        [CategoryField.MAT]: "materiels-professionnels",
        [CategoryField.VEH]: "vehicules"
    };

    constructor(
        private configService,
        private sitesService,
        private utilsService
    ) { }

    public buildSaleUrl(sale) {
        const isAuctionUrl = this.isAuctionUrl(sale.sites);
        return this._buildSaleUrl(sale.category.field, sale, isAuctionUrl);
    }

    public buildItemUrl(item, galleryName) {
        const isAuctionUrl = this.isAuctionUrl(item.sale.sites);

        if (isAuctionUrl) {
            return this.buildAuctionItemUrl(item);
        }

        const saleUrl = this._buildSaleUrl(item.category.field, item.sale, isAuctionUrl);

        return this.addUtmForLeMag(`${saleUrl}lot-${item.id}.html`, galleryName);
    }

    private addUtmForLeMag(url, galleryName) {
        const utm = {
            utm_source: "LEMAG",
            utm_medium: "article",
            utm_campaign: `LEMAG_${this.utilsService.slugify(galleryName)}`
        };

        return `${url}?${new URLSearchParams(utm).toString()}`;
    }

    private buildBasePath(isAuctionUrl) {
        return `${isAuctionUrl ?
            this.configService.auction.url :
            this.configService.ie.url
        }/`;
    }

    private _buildSaleUrl(categoryField: CategoryField, sale: thor.SaleGet, isAuctionUrl: boolean) {
        const basePath = this.buildBasePath(isAuctionUrl);
        const treePath = `${isAuctionUrl ?
            "vente" :
            IeUrlBuilderService.FIELDS[categoryField]
        }/`;
        const slugifiedName = this.utilsService.slugify(sale.name);

        return `${basePath}${treePath}${slugifiedName}-${sale.id}/`;
    }

    private buildAuctionItemUrl(item: thor.ItemGet) {
        const basePath = this.buildBasePath(true);
        const slugifiedDescription = this.formatAuctionSlug(item.description);

        return `${basePath}lot/${slugifiedDescription}-${item.id}`;
    }

    private formatAuctionSlug(text: string): string {
        if (!text) {
            return text;
        }
        const MAX_LENGTH = 90;

        text = slugify(text);

        if (text.length < MAX_LENGTH || !text.includes("-")) {
            return text;
        }
        text = text.substring(0, MAX_LENGTH);
        return text.substring(0, text.lastIndexOf("-"));
    }

    private isAuctionUrl(sites: thor.SaleSites): boolean {
        const isAuction = this.sitesService.isAuction(sites);
        const isIE = this.sitesService.isIE(sites);

        return isAuction && !isIE;
    }
}
